import React, { PropsWithChildren, ReactNode } from 'react';
import isNil from 'lodash/isNil';
import { QuoteUnitsOfMeasureSelector } from '../../../store/selectors/coreSelectors';
import { useDictionaryItem } from './useDictionaryItem';

interface UnitOfMeasureProps {
  value?: number | null;
  fallback?: ReactNode;
}

export const UnitOfMeasure = ({ value, children, fallback = null }: PropsWithChildren<UnitOfMeasureProps>) => {
  const label = useDictionaryItem(QuoteUnitsOfMeasureSelector, value);

  if (isNil(children)) {
    return <>{fallback}</>;
  }

  if (!label) {
    return <>{children}</>;
  }

  return <>
    {children}
    {' '}
    {label}
  </>;
};
